// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"b5f1baed","189":"e46caf53","254":"615c3d9e","281":"f464a6ea","444":"21b65572","447":"bb996cd3","568":"f9bd47cf","885":"478230c2"}[chunkId] + ".chunk.css";
};